export default "/profile/images/Apix-Drive.svg?ea659d8d800bf0df221db6a179c50d8c";